import { useCallback, useEffect, useMemo, useState } from "react";
import useApi from "../../../core/customhook/useApi";
import {
  fetch_employee_list,
  get_employee_by_id,
  get_new_emp_by_id,
} from "../../../environment";

type Option = {
  value: string;
  label: string;
};

export interface EmployeeDetailsTypes {
  AnnualCTC: number;
  band: string;
  branch_name: string;
  department: string;
  designation: string;
  employee_id: string;
  employee_name: string;
}

export function useEmployeeHook() {
  const [employeeList, setEmployeeList] = useState<
    { employee_id: string; employee_name: string }[]
  >([]);
  const [employeeDataById, setEmployeeDataById] =
    useState<EmployeeDetailsTypes | null>(null);
  const [employeeId, setEmployeeId] = useState<string | null>(null);
  const [newJoinerId, setNewJoinerId] = useState<string | number | null>(null);
  const [newJoinerDataById, setNewJoinerDataById] = useState<any | null>(null);

  const { callApi: employeeApi } = useApi(fetch_employee_list, {
    method: "GET",
    autoCall: false,
  });
  const { callApi: employeeByIdApi, loading: loading_employeeById } = useApi(
    get_employee_by_id,
    {
      method: "POST",
      autoCall: false,
    },
  );
  const { callApi: newJoinerByIdApi, loading: loading_newJoinerById } = useApi(
    "",
    {
      method: "GET",
      autoCall: false,
    },
  );

  const fetchData = useCallback(async () => {
    try {
      const resp = await employeeApi();
      if (resp.success) {
        setEmployeeList(resp.data ?? []);
      }
    } catch (error) {
      console.log("error while fetching:", error);
    }
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // ---- get employee data by id ----
  const fetchDataByID = useCallback(async () => {
    if (!employeeId) return;
    try {
      const resp = await employeeByIdApi({
        EmployeeId: employeeId,
      });
      // console.log("emp data by id :", resp);
      if (resp.success) {
        setEmployeeDataById(resp.data ?? null);
      }
    } catch (error) {
      console.log("error while fetching:", error);
    }
  }, [employeeId]);
  useEffect(() => {
    fetchDataByID();
  }, [fetchDataByID]);
  // ---- /get employee data by id ----

  // ---- get new-joiner data by id ----
  const fetchNewJoinerDataByID = useCallback(async () => {
    if (!newJoinerId) return;
    try {
      const resp = await newJoinerByIdApi(
        undefined,
        `${get_new_emp_by_id}/${newJoinerId}`,
      );
      // console.log("emp data by id :", resp);
      if (resp.success) {
        setNewJoinerDataById(resp.data ?? null);
      }
    } catch (error) {
      console.log("error while fetching:", error);
    }
  }, [newJoinerId]);
  useEffect(() => {
    fetchNewJoinerDataByID();
  }, [fetchNewJoinerDataByID]);
  // ---- /get new-joiner data by id ----

  const EmployeeOptions: Option[] = useMemo(() => {
    if (!employeeList?.length) return [];
    return employeeList?.map((itm) => ({
      value: itm?.employee_id,
      label: itm?.employee_name + " - " + itm.employee_id,
    }));
  }, [employeeList]);

  return {
    EmployeeOptions,
    setEmployeeId,
    setNewJoinerId,
    employeeDataById,
    newJoinerDataById,
    loading_newJoinerById,
    loading_employeeById,
  };
}
